import { Versions } from '../constants/versions';

export interface AboutParams {
	version?: Versions;
}

export class About {
	version?: Versions;
	constructor(cfg: AboutParams = {}) {
		const { version = '1.0.3' } = cfg;
		this.version = version;
	}

	static fromJSON(aboutJSON: string): About {
		const _about = JSON.parse(aboutJSON);

		return new About(_about);
	}
}
